var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2"},[_c('h3',{staticClass:"pb-2 border-bottom"},[_vm._v("Acessos")]),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.acessos_comp,"fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }